
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.55 10.56H5.44a.25.25 0 0 1-.24-.16.26.26 0 0 1 .07-.28l8.64-7.6A1.44 1.44 0 0 0 12 .36L.83 10.2A2.43 2.43 0 0 0 0 12a2.4 2.4 0 0 0 .82 1.8L12 23.64a1.44 1.44 0 1 0 1.9-2.16l-8.64-7.6a.26.26 0 0 1-.07-.28.25.25 0 0 1 .24-.16h17.12a1.44 1.44 0 0 0 0-2.88Z"}})])
          )
        }
      }
    